let button = document.querySelector('.shop-sidebar__filter-btn'); 
let closeBtn = document.querySelector('.pop-up__close');
button && button.addEventListener('click', function() {
  const modal = document.querySelector('.shop-sidebar__filter-pop-up');

  modal.style.display = 'block';
  modal.style.top = window.pageYOffset + 'px';
  modal.style.opacity = '1';
  document.getElementsByTagName('body')[0].classList.add('frozen');

  function closeModal() {
    modal.style.opacity = '0';
    setTimeout( function() {
      modal.style.display = 'none';
    }, 1000);
    document.getElementsByTagName('body')[0].classList.remove('frozen');
  }

  closeBtn.addEventListener('click', function() {
    closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
});

let queryString = window.location.search;

let urlParams = new URLSearchParams(queryString);
const product = urlParams.get('min_price');

const product2 = urlParams.get('product');
if ( document.getElementById('filter')) {
  const inputs = Array.from(document.getElementById('filter').querySelectorAll('input.filter-input'));
  [].forEach.call(inputs, function(input) {
    let value = input.value;
    let name = input.name;
    //check if filter name already in url
    if ( urlParams.has(name)) {
      let paramNames = urlParams.getAll(name);
      [].forEach.call(paramNames, function(paramName) {
      //check if this value in url
        if ( value == paramName) {
          input.setAttribute('checked', ' ');
        }
      });
    }

    let label = input.parentElement;
    label.addEventListener('click', function() {
      input.toggleAttribute('checked');
    });

  });
}

function setURLSearchParam(key, value) {
  const url = new URL(window.location.href);
  url.searchParams.append(key, value);
  window.history.pushState({ path: url.href }, '', url.href);
}

function removeURLSearchParam(name, value) {
  const url = new URL(window.location.href);
  const entries = url.searchParams; 
  const tags = entries.getAll(name).filter(name => name !== value);
  entries.delete(name);
  for (const tag of tags) entries.append(name, tag);
  window.history.pushState({ path: url.href }, '', url.href);
}

const inputs = Array.from(document.getElementById('filter').querySelectorAll('input.filter-input'));
document.getElementById('filter') && document.getElementById('filter').addEventListener('submit', function(e) {
  e.preventDefault();
  [].forEach.call(inputs, function(input) {

    let value = input.value;
    let name = input.name;
    let queryString = window.location.search;

    let urlParams = new URLSearchParams(queryString);

    //check if filter name already in url
    if ( urlParams.getAll(name).includes(value) === true && input.checked === true ) {
    } else if ( urlParams.getAll(name).includes(value) !== true && input.checked === true ) {
      setURLSearchParam(name, value);
    } else if ( urlParams.getAll(name).includes(value) == true && input.checked === false ) {
      removeURLSearchParam(name, value);
    }
  });

  let minPrice = document.getElementById('min_price');
  let maxPrice = document.getElementById('max_price');
  let url = new URL(window.location.href);

  if (urlParams.has(minPrice.name) ){
    url.searchParams.delete(minPrice.name);
  }
  url.searchParams.append(minPrice.name, minPrice.value);

  if (urlParams.has(maxPrice.name)) {
    url.searchParams.delete(maxPrice.name);
  }
  url.searchParams.append(maxPrice.name, maxPrice.value);

  window.history.pushState({ path: url.href }, '', url.href);
  window.location.replace(window.location.href);
});

document.getElementById('clear-all') && document.getElementById('clear-all').addEventListener('click', function() {
  let inputs = document.querySelectorAll('input.filter-input');
  const url = new URL(window.location.href);

  [].forEach.call(inputs, function(input) {
    let name = input.name;
    url.searchParams.delete(name);
    input.removeAttribute('checked');
  });

  url.searchParams.delete('min_price');
  url.searchParams.delete('max_price');
  window.history.pushState({ path: url.href }, '', url.href);
});

document.querySelector('.filter__clear-column') && document.querySelector('.filter__clear-column').addEventListener('click', function() {
  let inputs = Array.from(this.parentElement.querySelectorAll('input.filter-input'));
  const url = new URL(window.location.href);

  [].forEach.call(inputs, function(input) {
    let name = input.name;
    url.searchParams.delete(name);
    input.removeAttribute('checked');
  });

  window.history.pushState({ path: url.href }, '', url.href);
});

document.querySelector('.filter__clear-price-column') && document.querySelector('.filter__clear-price-column').addEventListener('click', function() {
  let inputs = document.querySelector('.price_slider_amount').querySelectorAll('input');
  const url = new URL(window.location.href);

  [].forEach.call(inputs, function(input) {
    let name = input.name;
    url.searchParams.delete(name);
  });

  window.history.pushState({ path: url.href }, '', url.href);
});



// WEBPACK FOOTER //
// ./resources/assets/js/filter.js